import { fetchDonationsByCustomQuery } from '~api/DonationsAPI/handlers/DonationsHandler';
import { mapDonations } from '~api/DonationsAPI/mappers/DonationsMappers';

import { IDonationsConfigItem } from '~domain/entities/Config/IConfig';

export const fetchByCategory = async (categories: IDonationsConfigItem) => {
    const byCategoryIds = { tags: { ids: categories.ids } };
    const rawCategory = await fetchDonationsByCustomQuery(byCategoryIds);

    return mapDonations(rawCategory[0], categories.description);
};
